// Polished line icons for the left navigation rail. Hand-rolled (no icon dep)
// so we control stroke weight + corners. 24px viewBox, 1.75 stroke,
// currentColor — they inherit the rail button's active/idle color.

import React from "react";
import { Icon } from "@chakra-ui/react";

function Line({ children, ...rest }) {
  return (
    <Icon
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...rest}
    >
      {children}
    </Icon>
  );
}

// Workspace — a sparkle, for the AI workspace surface.
export function WorkspaceIcon(props) {
  return (
    <Line {...props}>
      <path d="M12 3l1.7 6.3L20 11l-6.3 1.7L12 19l-1.7-6.3L4 11l6.3-1.7z" />
      <path d="M18.5 4.5l.5 1.7 1.7.5-1.7.5-.5 1.7-.5-1.7L16.3 6.7l1.7-.5z" />
    </Line>
  );
}

// Manager engagement - a compact trend chart.
export function EngagementIcon(props) {
  return (
    <Line {...props}>
      <path d="M4 19V9" />
      <path d="M10 19V5" />
      <path d="M16 19v-7" />
      <path d="M22 19V3" />
    </Line>
  );
}

// Threads — overlapping conversation bubbles (a stack of threads).
export function ThreadsIcon(props) {
  return (
    <Line {...props}>
      <path d="M8 13.5A2.5 2.5 0 0 1 5.5 16H5l-2.5 2.5v-8A2.5 2.5 0 0 1 5 8h6a2.5 2.5 0 0 1 2.5 2.5v.5" />
      <path d="M21.5 5.5A2.5 2.5 0 0 0 19 3h-6a2.5 2.5 0 0 0-2.5 2.5v4A2.5 2.5 0 0 0 13 12h5l3.5 3v-9.5z" />
    </Line>
  );
}

// Conversations — a single chat bubble.
export function ConversationsIcon(props) {
  return (
    <Line {...props}>
      <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8z" />
    </Line>
  );
}

// Audio Batches — a waveform.
export function AudioIcon(props) {
  return (
    <Line {...props}>
      <path d="M5 10v4" />
      <path d="M9 6v12" />
      <path d="M12 3v18" />
      <path d="M15 6v12" />
      <path d="M19 10v4" />
    </Line>
  );
}

// Test Audio — a lab flask.
export function FlaskIcon(props) {
  return (
    <Line {...props}>
      <path d="M9 3h6" />
      <path d="M10 3v6.2L5.4 17.5A2 2 0 0 0 7.1 20.5h9.8a2 2 0 0 0 1.7-3L14 9.2V3" />
      <path d="M8.2 14h7.6" />
    </Line>
  );
}

// Admin — a shield with a check.
export function AdminIcon(props) {
  return (
    <Line {...props}>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      <path d="M9 12l2 2 4-4" />
    </Line>
  );
}

export function LogoutIcon(props) {
  return (
    <Line {...props}>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <path d="M16 17l5-5-5-5" />
      <path d="M21 12H9" />
    </Line>
  );
}

export function SignatureIcon(props) {
  return (
    <Line {...props}>
      <path d="M3 17c3 0 3-9 6-9s2 7 4 7 2-4 4-4" />
      <path d="M3 21h18" />
    </Line>
  );
}
